import WebSocketService from './websocket'
import { Message, MessageBox } from 'element-ui'
import { getRequestId } from '@/utils/wsConfig'
import { EventBus } from '@/utils/eventBus'

// 初始化WebSocket
export function initWebSocket({ state, commit, dispatch }, { url, options }) {
  try {
    const wsService = new WebSocketService(url, {
      ...options,
      onMessage: message => {
        EventBus.$emit('messageSent', 'sendOk')
        dispatch('handleMessage', message)
      },
      onClose: () => {},
      onError: () => {}
    })
    commit('setWsService', wsService)
  } catch (error) {
    if (state.wsService) {
      state.wsService.reconnect()
    }
  }
}

// 处理返回消息
export async function handleMessage({ state, dispatch, commit }, res) {
  if (res.code !== 200) {
    return dispatch('handleCode', res)
  }
  if (res.type !== 4) {
    return dispatch('handleType', res)
  }

  // 确认消息已接收到，并发送ack响应
  dispatch('sendAckMessage', res)

  // 消费待处理消息
  const task = state.wsService.messageQueue[res.requestId]
  if (task) {
    task.resolve(res)
    // 删除已处理任务
    commit('deleteMessageTask', res.requestId)
  } else {
    if (res.data && res.data.length) {
      res.data.forEach(msg => dispatch('formatReceiveMsg', msg))
    }
  }
}

// 发送消息
export async function sendMessage({ state, commit }, data) {
  if (state.wsService && state.wsService.socket && state.wsService.socket.readyState === WebSocket.OPEN) {
    const res = await new Promise((resolve, reject) => {
      const requestId = getRequestId()
      // 保存消息任务
      commit('addMessageTask', { requestId, resolve, reject })
      data['requestId'] = requestId
      state.wsService.socket.send(JSON.stringify(data))
    })
    commit('setFormatReceiveMsg', res)
    commit('evEventChat', 'evEventMessage')
    return res
  } else {
    console.warn('++++', 'WebSocket未连接，无法发送消息')
  }
}

// WebSocket关闭
export function closeWebSocket({ state, commit }) {
  if (state.wsService) {
    state.wsService.close()
    commit('setWsService', null)
  }
}

// 发送ack消息
export async function sendAckMessage({ dispatch }, res) {
  let messageIdList = []
  if (res.data) {
    messageIdList = res.data.map(item => item.messageId)
  }

  dispatch('sendMessage', {
    msgType: 8,
    dialogId: res.dialogId,
    body: {
      subType: 3,
      content: {
        messageIdList
      }
    }
  })
}

/**
 * 处理不同的 WebSocket 消息错误代码：
 * - 400: 无效参数，客户端传递的参数不符合要求
 * - 401: 鉴权失败，身份验证未通过
 * - 501: 参数解析错误，服务器无法正确解析传递的参数
 * - 502: 建立连接失败，服务器或网络问题导致连接失败
 * - 503: 查询会话为空，无法找到相关会话记录
 * - 504: 重连机制超过限制，等待一分钟后再次重试
 * - 505: 不支持的消息类型，当前消息类型未被支持
 * - 506: 当前会话已关闭，可能是因为多窗口会话导致其他窗口关闭
 * - 201: 正常关闭，客户端或服务器正常关闭连接
 * - 703: 消息发送失败，清空任务队列
 */
export function handleCode({ state, dispatch }, res) {
  switch (res.code) {
    case 201:
    case 400:
    case 401:
    case 501:
    case 502:
    case 503:
    case 505:
    case 506:
      Message.warning(res.msg || '建立连接失败!')
      dispatch('closeWebSocket')
      break
    case 504:
      state.wsService.exceedLimit()
      break
    case 703:
      Message.warning(res.msg || '消息发送失败!')
      state.wsService.clearTaskQueue()
      break
  }
}

/** 消息类型处理逻辑说明：
 * type = 2: 心跳消息，用于维持 WebSocket 连接的活跃状态。
 * type = 3: 连接建立成功，WebSocket 已成功连接。
 * type = 4: 接收到新消息，通常为用户或系统消息的传递。
 * type = 5: 正在输入消息，表示用户正在输入内容的状态更新。
 * type = 6: 多窗口接线冲突，显示警告并关闭 WebSocket 连接。
 * type = 7: 消息回执，确认消息已成功发送或接收的状态更新。
 * type = 10: 刷新页面。
 * type = 11: 推送左侧会话列表
 */
export function handleType({ dispatch, commit }, res) {
  switch (res.type) {
    case 5:
      if (!res.requestId) {
        commit('setFormatReceiveMsg', res)
        commit('evEventChat', 'evEventTyping')
      }
      break
    case 6:
      MessageBox.confirm('当前组织已在其他页面接线，用户消息在新开页面展示，手动切换组织或关闭菜单!', '提示', {
        showClose: false,
        closeOnClickModal: false,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {})
        .catch(() => {})
      dispatch('closeWebSocket')
      break
    case 10:
      MessageBox.confirm('当前网络异常，请尝试刷新页面重新加载！', '提示', {
        showClose: false,
        closeOnClickModal: false,
        confirmButtonText: '刷新',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          location.reload()
        })
        .catch(() => {})
      break
    case 11:
      commit('setUserDialogList', res.data)
      commit('evEventChat', 'evEventChatList')
      break
    default:
      break
  }
}

export default {
  initWebSocket,
  sendMessage,
  handleMessage,
  closeWebSocket,
  sendAckMessage,
  handleCode,
  handleType
}
